// extracted by mini-css-extract-plugin
export default {"wrapper":"Bp08VAaovWi6owJNkH7g"};